export * from './download.service';
export * from './download.interface';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/download/shared/index.ts